import { gql } from 'graphql-tag';

export const GET_LABELS = gql`
  query GetLabels($pagination: PaginationInput) {
    labels(pagination: $pagination) {
      data {
        id
        name
        slug
        color
        accountId
        createdAt
        updatedAt
      }
      meta {
        page
        limit
        total
        totalPages
        hasNext
        hasPrev
      }
    }
  }
`;

export const GET_LABEL = gql`
  query GetLabel($id: ID!) {
    label(id: $id) {
      id
      name
      slug
      color
      accountId
      createdAt
      updatedAt
    }
  }
`;
